import type { AnnotationType } from '@/core/annotationTypes'

export const BOUNDING_BOX_ANNOTATION_TYPE: AnnotationType = 'bounding_box'
